import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { UserType } from "../../Variables";
import { ExistingApplicationModel } from "../../../apis/ApisPositions";

export type CreateApplicationCardProps = {
    ExistingApplications: ExistingApplicationModel[],
    existingToCopy: number | null;
    setExistingToCopy: (val: number | null) => void,
}

export function CreateApplicationCard(props: CreateApplicationCardProps) {
    const app = useContext(AppContext);

    return (
        <div className="card shadow card-secondary bg-alt mt-4 mb-3" id="createApplicationCard">
            <div className="card-body extra-central-padding min-height-200px">
                <h2>Create application</h2>
                <hr className="ShortBlock" />
                <p>
                    You have previously started an application with {app.firmName}.
                    If you would like to use your existing application as an editable template, please select from the dropdown below.
                </p>
                <p>
                    If you would like to start a new application select 'Create new application' in the dropdown.
                </p>
                <div className="col-auto">
                    {app.loggedInUser.UserType == UserType.Candidate && <label htmlFor="existingPositionCopy" className="form-label">Please remember to check that your personal details are up to date.</label>}
                    {(app.loggedInUser.UserType == UserType.Admin || app.loggedInUser.UserType == UserType.Agency) && <label htmlFor="existingPositionCopy" className="form-label">Please remember to check that the candidate's personal details are up to date.</label>}
                    <div className="input-group">
                        <select onChange={x => {
                            x.preventDefault();
                            let value = x.currentTarget.value == null || x.currentTarget.value == "Create new application" ? null : Number.parseInt(x.currentTarget.value);
                            props.setExistingToCopy(value);
                        }} id="existingPositionCopy" className="form-select" aria-label="Create new position of copy existing">
                            <option value={null} key={"Create new"}>Create new application</option>
                            {props.ExistingApplications.map(x => {
                                return <option value={x.ApplicationNumber} key={`AF_existing_${x.ApplicationNumber}`}>{x.ApplyingFor}</option>
                            })}
                        </select>
                        <button disabled={props.existingToCopy == null} className="btn btn-contrast-alt" type="button" id="btn-change" onClick={x => {
                            x.preventDefault();
                            window.open(`/Preview/?app=${props.existingToCopy}`, '_blank');
                        }}>View application</button>
                    </div>
                </div>
            </div>
        </div>
    );
}